import { AppQueryParams } from '../constants/queryParams';
import {
  DODA_CAREERRECOMMENDJOB_LIST,
  DODA_INTENTIONJOB_LIST,
  DODA_LATEST_CHECK_OFFER,
  DODA_NEW_OFFER,
  DODA_OFFER_SP,
  DODA_QUALIFICATION_LIST,
  DODA_ROUTE_LIST,
  DODA_SEARCH_CONDITION_SAVE,
  DODA_SEARCH_RESULT_DETAIL,
  DODA_SEARCH_RESULT_LEFTPANEL_AR,
  DODA_SEARCH_RESULT_LEFTPANEL_IND,
  DODA_SEARCH_RESULT_LEFTPANEL_NO,
  DODA_SEARCH_RESULT_LEFTPANEL_OC,
  DODA_SEARCH_TOP,
  DODA_SEMINAR_DETAIL_CONSULTANT,
  DODA_SEMINAR_DETAIL_INFO_SESSION,
  DODA_SEMINAR_LIST,
  DODA_STATION_LIST,
  DRILL_DOWN_AR,
  DRILL_DOWN_IND,
  DRILL_DOWN_OC,
  EVENT_CONSULT,
  EVENT_EXPLAN,
  NUMERIC_1,
} from '../constants/seo';
import { DODA_SITE_URL } from '../constants/urls';
import {
  extractScreenKindCondition,
  isOnlyValueInMap,
  isTwoValueInMap,
  onlyOneKeyExistsInKodawari,
  isEmptyArray,
} from '../utils/seoUtil';

export interface ScreenKindOption {
  ntab?: string;
  eventKind?: string;
}
export const getSearchScreenKind = (
  path: string,
  condition: AppQueryParams,
  option: ScreenKindOption
) => {
  const { preBtn, ha, ne, es } = condition;
  const { ntab, eventKind } = option;
  const kindCondition = extractScreenKindCondition(condition);
  const { op, ...cond } = kindCondition;
  // こだわりが何も設定されていないか、何か一つだけ設定されているか、op×opかop×haである
  const isOnlyOpValue =
    (isEmptyArray([op, ha, ne, es]) ||
      onlyOneKeyExistsInKodawari(condition) ||
      (isTwoValueInMap(condition) && isEmptyArray([ne, es]))) &&
    isOnlyValueInMap(cond);
  if (DODA_SITE_URL.jobSearchList === path) {
    if (preBtn) {
      // ★seo遷移図の7～12行目★
      // １URLが詳細検索結果の場合、左パネルの種別＝職種ドリルダウンの場合
      if (DRILL_DOWN_OC === preBtn) {
        if (!isOnlyOpValue) return 0;
        return DODA_SEARCH_RESULT_LEFTPANEL_OC;
        // ★seo遷移図の13～30行目★
        // ２URLが詳細検索結果の場合、左パネルの種別＝エリアドリルダウンの場合
      }
      if (DRILL_DOWN_AR === preBtn) {
        if (!isOnlyOpValue) return 0;
        return DODA_SEARCH_RESULT_LEFTPANEL_AR;
        // ★seo遷移図の31～50行目★
        // ３URLが詳細検索結果の場合、左パネルの種別＝業種ドリルダウンの場合
      }
      if (DRILL_DOWN_IND === preBtn) {
        if (!isOnlyOpValue) return 0;
        return DODA_SEARCH_RESULT_LEFTPANEL_IND;
      }
    }

    return DODA_SEARCH_RESULT_LEFTPANEL_NO;
  }

  // ★seo遷移図の53～53行目★
  // URLが求人原稿の場合
  if (DODA_SITE_URL.jobSearchDetail === path) {
    return DODA_SEARCH_RESULT_DETAIL;
  }

  // ★seo遷移図の55～55行目★
  // URLが検索トップの場合
  if (DODA_SITE_URL.jobSearchTop === path) {
    return DODA_SEARCH_TOP;
  }

  // ★seo遷移図の59～60行目★
  // ・サイト区分が10：DODA、URLが検索条件保存の場合
  if (DODA_SITE_URL.recommendJobList === path) {
    return DODA_SEARCH_CONDITION_SAVE;
  }

  // ★seo遷移図の61～62行目★
  // URLがセミナー一覧（企業別）、セミナー一覧（一覧） の場合
  if (DODA_SITE_URL.seminarList === path) {
    return DODA_SEMINAR_LIST;
  }

  // ★seo遷移図の63～63行目★
  // URLがセミナー詳細_会社説明会（有料）の場合
  if (DODA_SITE_URL.seminarDetail === path) {
    if (EVENT_EXPLAN === eventKind) {
      return DODA_SEMINAR_DETAIL_INFO_SESSION;
    }
    if (EVENT_CONSULT === eventKind) {
      return DODA_SEMINAR_DETAIL_CONSULTANT;
    }
  }

  // ★seo遷移図の66～66行目★
  // URLが新着求人の場合
  if (DODA_SITE_URL.newJobList === path && NUMERIC_1 === Number(ntab)) {
    return DODA_NEW_OFFER;
  }

  // ★seo遷移図の67～67行目★
  // URLが求人特集の場合
  if (DODA_SITE_URL.featuredJobList === path) {
    return DODA_OFFER_SP;
  }
  // ★seo遷移図の68～68行目★
  // URLが最近見た求人の履歴の場合
  if (DODA_SITE_URL.jobHistoryList === path) {
    return DODA_LATEST_CHECK_OFFER;
  }

  // URLが地域別路線一覧画面の場合
  if (DODA_SITE_URL.routeList === path) {
    return DODA_ROUTE_LIST;
  }
  // URLが路線別駅名一覧画面の場合
  if (DODA_SITE_URL.stationList === path) {
    return DODA_STATION_LIST;
  }
  // URLが気になる履歴をもとにしたおすすめの求人一覧画面の場合
  if (DODA_SITE_URL.intentionJobList === path) {
    return DODA_INTENTIONJOB_LIST;
  }
  // ・サイト区分が10:DODAの時、URLが資格・経歴スキル求人一覧画面の場合
  if (DODA_SITE_URL.careerRecommendJobList === path) {
    return DODA_CAREERRECOMMENDJOB_LIST;
  }
  // ・サイト区分が10:DODAの時、URLが全資格一覧画面の場合
  if (DODA_SITE_URL.qualificationList === path) {
    return DODA_QUALIFICATION_LIST;
  }

  return 0;
};
